import { darken, lighten } from "@mui/system/colorManipulator";
import componentOverrides from "../component-overrides";
var tonalOffset = 0.2;
function addLightAndDark(main) {
    return {
        main: main,
        light: lighten(main, tonalOffset),
        dark: darken(main, tonalOffset * 1.5)
    };
}
var theme = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xxl: 1650
        }
    },
    components: componentOverrides,
    typography: {
        fontSize: 13
    },
    palette: {
        contrastThreshold: 3,
        background: {
            default: "#F8FDFC"
        },
        primary: {
            light: "#395768",
            main: "#0c2e3d",
            dark: "#000417"
        },
        secondary: {
            light: "#FEEFD8",
            main: "#F5A623",
            dark: "#EF8B2C"
        },
        // NOTE: The following are used for status boxes, andon buttons etc.
        error: {
            light: "#FAE4E6",
            main: "#D0021B",
            dark: "#A10215"
        },
        warning: {
            light: "#FEEFD8",
            main: "#F5A623",
            dark: "#EF8B2C"
        },
        info: {
            light: "#E9F8E9",
            main: "#59B78C",
            dark: "#428768"
        }
    },
    blackbird: {
        alarms: {
            type: {
                AboveX: {
                    color: "#d9534f"
                },
                BelowX: {
                    color: "#d9534f"
                },
                AboveXForTSeconds: {
                    color: "#5bc0de"
                },
                BelowXForTSeconds: {
                    color: "#5bc0de"
                },
                AboveXForTSecondsWithinYTimeNTimes: {
                    color: "#f0ad4e"
                },
                BelowXForTSecondsWithinYTimeNTimes: {
                    color: "#f0ad4e"
                },
                SumOfTAboveXWithinYTime: {
                    color: "purple"
                },
                SumOfTBelowXWithinYTime: {
                    color: "purple"
                }
            }
        },
        stops: {
            NO_ACT: {
                color: addLightAndDark("#ADDFEF")
            },
            NON_PROD: {
                color: addLightAndDark("#E0E0E0")
            },
            BATCH_NON_PROD: {
                color: addLightAndDark("#F8D6A7")
            },
            DOWNTIME: {
                color: addLightAndDark("#D99896")
            },
            UNREGISTERED: {
                color: addLightAndDark("#BDBDBD")
            },
            MICRO_STOP: {
                color: addLightAndDark("#E0E0E0")
            },
            UNREGISTERED_PLOT_BAND: {
                color: addLightAndDark("#D99896")
            }
        },
        tableRows: {
            color: {
                hovered: "lightgray"
            }
        }
    }
};
export var base = theme;
